import React, { RefObject } from "react";
import {
    TeachingPopover,
    TeachingPopoverSurface,
} from "@fluentui/react-components";

type Option = {
    label: string;
    value: string;
    HasComposition?: boolean;
    disabled?: boolean;
};

type Props = {
    value: string;
    options: Option[];
    onChange: (value: string) => void;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    targetRef: RefObject<HTMLElement>;
    surfaceWidth?: number | string;
    surfaceMinWidth?: number | string;
};

export default function CustomDropdown({
    value,
    options,
    onChange,
    open,
    onOpenChange,
    targetRef,
    surfaceWidth,
    surfaceMinWidth = 160,
}: Props) {
    return (
        <TeachingPopover
            open={open}
            onOpenChange={(_, data) => onOpenChange(data.open)}
            positioning={{
                position: "below",
                align: "start",
                target: targetRef.current,
            }}
        >
            <TeachingPopoverSurface
                style={{
                    padding: 0,
                    width: surfaceWidth,
                    minWidth: surfaceMinWidth,
                    zIndex: 10000,
                }}
            >
                <div className="max-h-60 overflow-auto">
                    {options.map((opt) => (
                        <div
                            key={opt.value}
                            onClick={() => {
                                if (opt.disabled) return;

                                onChange(opt.value);
                                onOpenChange(false);
                            }}
                            className={`
                                px-4 py-2 text-xs cursor-pointer flex justify-between
                                ${opt.disabled
                                    ? "opacity-40 cursor-not-allowed"
                                    : "hover:bg-gray-100 dark:hover:bg-gray-800"
                                }
                            `}
                        >
                            <span
                                className={
                                    opt.HasComposition
                                        ? "underline"
                                        : ""
                                }
                            >
                                {opt.label}
                            </span>

                            {opt.value === value && (
                                <span className="text-xs opacity-70"> <svg
                                    className="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg></span>
                            )}
                        </div>
                    ))}
                </div>
            </TeachingPopoverSurface>
        </TeachingPopover>
    );
}